export default __webpack_public_path__ + "67eb59ca0baec08f4df819a2d8beaad7.svg";